module.exports = __webpack_public_path__ + "img/item.572eb8d5.png";